"use client";

import { motion } from "framer-motion";
import { Card } from "@mui/material";
import Logo from "../../../Static/RoundedRTSIcon.png";

export default function TeamSection() {
  const team = [
    {
      name: "Nilesh Gajjar",
      role: "Founder",
      description:
        "Nilesh Gajjar is the visionary founder of the platform, bringing over 30 years of experience in the field of tax planning and financial consulting. With a strong track record in helping businesses streamline their financial operations, Nilesh leads the team in offering expert financial solutions.",
    },
    {
      name: "Manoj Mahto",
      role: "Senior Accounts Cum Taxation",
      description:
        "Manoj Mahto is a seasoned professional with in-depth knowledge of taxation and accounting. He has represented clients in high-profile tax cases and is well-regarded for his expertise in tax law, providing clients with tailored advice for effective tax strategies.",
    },
  ];

  return (
    <div className="relative py-20 bg-gradient-to-b from-white to-gray-50">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <svg
          className="absolute w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern
              id="grid"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M 40 0 L 0 0 0 40"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
                className="text-gray-100/60"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative container px-4 mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16 max-w-2xl mx-auto"
        >
          <h2 className="md:text-3xl text-xl font-bold mb-6">
            Meet Our
            <span className="text-[#151C62] border-b-2 border-[#151C62] pb-1">
              {" "}
              Expert Team
            </span>
          </h2>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-1 lg:grid-cols-2">
          {team.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              className="group"
            >
              <Card className="relative h-full bg-white/80 border-0 shadow-xl hover:scale-105 !transition-transform !duration-300">
                {/* Decorative Elements */}
                <div className="absolute inset-0 bg-gradient-to-br  to-transparent rounded-lg" />
                <div className="absolute -inset-0.5 bg-gradient-to-br from-white to-gray-100 opacity-100 group-hover:opacity-100 transition-opacity duration-500 rounded-lg" />

                <div className="relative p-8">
                  {/* Abstract Shape */}
                  <div className="absolute top-0 right-0 w-20 h-20">
                    <img src={Logo} alt="Logo" className="w-full h-full" />
                  </div>

                  <div className="space-y-4">
                    <div className="h-1 w-12 bg-gradient-to-r from-[#151C62] to-[#151C62] rounded-full" />
                    <h3 className="text-2xl font-bold tracking-tight group-hover:text-[#151C62] transition-colors">
                      {member.name}
                    </h3>
                    <p className="text-[#151C62] font-medium">{member.role}</p>
                    <p className="text-black leading-relaxed text-sm">
                      {member.description}
                    </p>
                  </div>

                  {/* Bottom Decoration */}
                  <div className="absolute bottom-4 right-4">
                    <motion.div
                      initial={{ scale: 0.5, opacity: 0 }}
                      animate={{ scale: 1, opacity: 0.1 }}
                      transition={{
                        repeat: Infinity,
                        repeatType: "reverse",
                        duration: 3,
                        delay: index * 0.5,
                      }}
                      className="w-12 h-12 rounded-full bg-[#151C62]"
                    />
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
